import { render, staticRenderFns } from "./OrderTrackingTable.vue?vue&type=template&id=113d3a6b&scoped=true&"
import script from "./OrderTrackingTable.vue?vue&type=script&lang=ts&"
export * from "./OrderTrackingTable.vue?vue&type=script&lang=ts&"
import style0 from "./OrderTrackingTable.vue?vue&type=style&index=0&id=113d3a6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113d3a6b",
  null
  
)

export default component.exports